<template>
  <div class="newhome-wrapper">
    <div class="d-flex flex-row " style="height:10px"></div>
    <div class="d-flex flex-row ">
      <div class="d-flex flex-row" ref="backgroundDiv" :style="backgroundStyle">
        <!-- 시작: 숫자 표시 -->
        <div class="first-row-stat-value" :style="numberPositionStyle">
          <template v-for="(char, index) in statChars" :key="index">
            <img 
              v-if="char.isNumber" 
              :src="char.imageSrc" 
              :alt="char.char"
              class="number-image"
            />
            <span v-else class="number-separator">{{ char.char }}</span>
          </template>
        </div>
        <!-- 끝: 숫자 표시 -->

        <!-- 시작: 전국 병원 지도 -->
        <div class="hospital-map" :style="hospitalMapPositionStyle">
          <img :src="hospitalMapImageSrc" alt="전국 병원 지도" class="hospital-map-image">
        </div>
        <!-- 끝: 전국 병원 지도 -->

        <!-- 시작: 자동 달 업데이트 -->
        <div class="auto-month-update" :style="autoMonthUpdatePositionStyle">
          <span class="auto-month-update-text">{{ displayMonth }}</span>
        </div>
        <!-- 끝: 자동 달 업데이트 -->

      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import api from '@/services/base/opt_index.js'

export default {
  name: 'Home',
  data() {
    return {
      backgroundImageSrc: require('../../assets/newhome/home.png'),
      
      imageWidth: null,
      imageHeight: null,
      hospitals: 0,
      total: 0,
      numberGap: 20, // 숫자 사이 간격 (px)

      numberLeft: 240, // 숫자 위치 left (px)
      numberTop: 485, // 숫자 위치 top (px)
      

      hospitalMapImageSrc: require('../../assets/newhome/map.png'),
      hospitalMapLeft: 820, // 병원 지도 위치 left (px)
      hospitalMapTop: 480, // 병원 지도 위치 top (px)
      
      autoMonthUpdateLeft: 685, // 자동 달 업데이트 위치 left (px)
      autoMonthUpdateTop: 570, // 자동 달 업데이트 위치 top (px)
    }
  },
  computed: {
    currentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      return `${year}년 ${month}월`;
    },
    statChars() {
      // const hospitalsStr = this.priceToString(this.hospitals || 0);
      let totalStr = String(this.total || 0);
      
      // 4자리면 앞에 0을 붙여서 5자리로 만들기
      if (totalStr.length === 4) {
        totalStr = totalStr.padStart(5, '0');
      }
      
      const fullText = `${totalStr}`;
      
      return fullText.split('').map((char, index) => {
        if (/\d/.test(char)) {
          // 숫자인 경우
          // 첫 번째 문자가 0이고 전체가 5자리인 경우 0_dark.png 사용
          const isFirstZero = index === 0 && char === '0' && fullText.length === 5;
          const imageSrc = isFirstZero 
            ? require('../../assets/newhome/0_dark.png')
            : require(`../../assets/newhome/${char}.png`);
          
          return {
            char: char,
            isNumber: true,
            imageSrc: imageSrc
          };
        } else {
          // 숫자가 아닌 경우 (공백, 쉼표 등) 텍스트로 표시
          return {
            char: char,
            isNumber: false
          };
        }
      });
    },
    backgroundStyle() {
      const style = {
        backgroundImage: `url(${this.backgroundImageSrc})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        justifyContent: 'center',
        position: 'relative',
      };
      
      if (this.imageWidth && this.imageHeight) {
        style.width = `${this.imageWidth}px`;
        style.height = `${this.imageHeight}px`;
        style.minWidth = `${this.imageWidth}px`;
        style.minHeight = `${this.imageHeight}px`;
        style.backgroundSize = `${this.imageWidth}px ${this.imageHeight}px`;
      } else {
        style.minHeight = '400px';
        style.minWidth = '400px';
        style.width = '100%';
        style.backgroundSize = 'auto';
      }
      
      return style;
    },
    numberPositionStyle() {
      return {
        position: 'absolute',
        display: 'flex',
        gap: `${this.numberGap}px`,
        top: `${this.numberTop}px`,
        left: `${this.numberLeft}px`,
      };
    },
    hospitalMapPositionStyle() {
      return {
        position: 'absolute',
        top: `${this.hospitalMapTop}px`,
        left: `${this.hospitalMapLeft}px`,
      };
    },
    autoMonthUpdatePositionStyle() {
      return {
        position: 'absolute',
        top: `${this.autoMonthUpdateTop}px`,
        left: `${this.autoMonthUpdateLeft}px`,
        zIndex: 10,
      };
    },
    displayMonth() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth() + 1; // 1-12
      
      let displayYear = currentYear;
      let displayMonth;
      
      // 3, 6, 9, 12월 업데이트 기준으로 한 달 뒤에 업데이트
      if (currentMonth >= 1 && currentMonth <= 3) {
        // 1, 2, 3월이면 전년도 12월 표시
        displayYear = currentYear - 1;
        displayMonth = 12;
      } else if (currentMonth >= 4 && currentMonth <= 6) {
        // 4, 5, 6월이면 3월 표시
        displayMonth = 3;
      } else if (currentMonth >= 7 && currentMonth <= 9) {
        // 7, 8, 9월이면 6월 표시
        displayMonth = 6;
      } else {
        // 10, 11, 12월이면 9월 표시
        displayMonth = 9;
      }
      
      return `${displayYear}년 ${String(displayMonth).padStart(2, '0')}월`;
    },
  },
  mounted() {
    this.loadBackgroundImage();
    
    api.getNewHomeData().then(response => {
      if (response.data && response.data.data) {
        this.hospitals = response.data.data.hospitals || 0;
        this.total = response.data.data.total || 0;
      }
    }).catch(error => {
      console.error('API 호출 실패:', error);
      this.hospitals = 0;
      this.total = 0;
    });
  },
  methods: {
    loadBackgroundImage() {
      const img = new Image();
      img.onload = () => {
        this.imageWidth = img.naturalWidth;
        this.imageHeight = img.naturalHeight;
      };
      img.src = this.backgroundImageSrc;
    },
    priceToString(price) {
      if (price == null || price === undefined) {
        return '0';
      }
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    },
}
</script>

<style lang="scss">
@import '@/assets/design.css';

.newhome-wrapper {
  min-width: fit-content;
  overflow-x: auto;
  overflow-y: auto;
}

.auto-month-update {
  font-family: NotoSansKR-Black !important;
  white-space: nowrap;
  
  .auto-month-update-text {
    font-family: NotoSansKR-Black !important;
    color: #01478C;
    font-size: 1.1em;
    font-weight: 900;
    text-align: center;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    white-space: nowrap;
  }
}

</style>
